import {
  setCookie,
  getCookie,
  get,
  insertParam,
  removeParam,
  magnify,
  arrayEdit,
  NegarshopCreateCustomAlert,
  NegarshopRemoveCustomAlert,
  archive_btn,
} from "./modules/utils";

// Attach to window for global access (HTML onclick, etc.)
window.setCookie = setCookie;
window.getCookie = getCookie;
window.get = get;
window.insertParam = insertParam;
window.removeParam = removeParam;
window.magnify = magnify;
window.arrayEdit = arrayEdit;
window.NegarshopCreateCustomAlert = NegarshopCreateCustomAlert;
window.NegarshopRemoveCustomAlert = NegarshopRemoveCustomAlert;
window.archive_btn = archive_btn;

// Import modules (they execute their own jQuery logic)
import "./modules/ui";
import "./modules/carousel";
import "./modules/product";
import "./modules/product-mockup";
import "./modules/cart";
import "./modules/search";
import "./modules/auth";
import "./modules/comments";
import "./modules/checkout";
import "./modules/pwa";
import "./modules/widgets";
import "./modules/_mega-menu";
import "./modules/mega-menu-tabs";
import "./modules/misc";
import "./modules/product-cart-box";
import "./modules/product-gallery";
import "./modules/customer-club";
import "./modules/addresses";
import "./modules/notifications";
import "./modules/waiting-list";
import "./modules/account";
import "./modules/popup";
import "./live-filter";
import "./modules/floating";
